export default function FormDescrption(props) {
  const { description } = props;

  return <label className="small text-muted">{description}</label>;
}
